<script lang="ts">
  import { impression, trackEvent } from '../util/snowplow';
  import Favourite from './Favourite.svelte';
  import PlayerNrkno from './PlayerNrkno.svelte';
  const campaign = `?utm_source=delta&utm_medium=promo_with_image&utm_campaign=mgp`;

  type Promo = {
    title: string;
    description: string;
    src: string;
    alt: string;
    url: string;
    contentId: string;
    pillText: 'Les på NRK.no' | 'Se i NRK TV' | 'Hør i NRK Radio';
    sourceMedium: 'tv' | 'radio' | undefined;
    favouriteContentType: 'series' | 'programs' | 'podcast' | undefined;
  };

  const promos: Promo[] = [
    {
      title: 'Er du enig med anmelderne?',
      description: 'Les anmeldelsen av finalelåtene her.',
      src: 'https://gfx.nrk.no/aRrLQXXtT0ul25fWxdadGQUMubYHvKxstv0QHOVds-Rw',
      alt: 'MGP 2024 Finale',
      url: 'https://www.nrk.no/anmeldelser/anmeldelse_-melodi-grand-prix-2024-_-fremforingene-i-finalen-1.16741843',
      contentId: '',
      pillText: 'Les på NRK.no',
      sourceMedium: undefined,
      favouriteContentType: undefined,
    },
    {
      title: 'Bakemesterskapet',
      description: 'Kommer på TV neste lørdag',
      src: 'https://gfx.nrk.no/Hfr4fmF3_h7lsKR9rofesQE9diT1H3x4I78Vdd334Ftg',
      alt: 'Bakemesterskapet',
      url: 'https://tv.nrk.no/serie/bakemesterskapet',
      contentId: 'bakemesterskapet',
      pillText: 'Se i NRK TV',
      sourceMedium: 'tv',
      favouriteContentType: 'series',
    },
    {
      title: 'Eurovision 1985 - triumfen med Bobbysocks',
      description: 'Historien om norges første seier i Eurovision.',
      src: 'https://gfx.nrk.no/BwR9WivvTsyq-_pOCSOpMg9_lGoD-5Uk3QB3PDWvCqyA',
      alt: 'Hele Historien',
      url: 'https://radio.nrk.no/podkast/hele_historien/sesong/eurovision-1985---triumfen-med-bobbysocks/l_3edff0e7-f6eb-466a-9ff0-e7f6eba66a6f',
      contentId: 'hele_historien',
      pillText: 'Hør i NRK Radio',
      sourceMedium: 'radio',
      favouriteContentType: 'podcast',
    },
    {
      title: 'MGP - skjelettene i skapet',
      description:
        "Melodi Grand Prix' historie har øyeblikk ikke alle vil snakke om. Her får du sannheten!",
      src: 'https://gfx.nrk.no/vUcHb18HXvhJdOP94Nf3Qw7I76l_7vjJ91VVqdjvXX1Q',
      alt: 'MGP - skjelettene i skapet',
      url: 'https://tv.nrk.no/program/MUHU31000023',
      contentId: 'MUHU31000023',
      pillText: 'Se i NRK TV',
      sourceMedium: 'tv',
      favouriteContentType: 'programs',
    },
  ];
</script>

<ul>
  {#each promos as promo}
    <li>
      {#if promo.alt === 'Bakemesterskapet'}
        <div class="video-wrapper">
          <div class="video">
            <PlayerNrkno videoId="e52ce348-ed91-4599-8535-26423b89d802" />
            <a
              href={promo.url + campaign}
              target="_blank"
              on:click={() =>
                trackEvent({
                  action: 'click:further-navigation-with-image',
                  label: promo.title,
                })}
              use:impression={`promo:image-${promo.alt}`}
            >
              <div class="bottomContent">
                <div class="text">
                  <div class="pillText">{promo.pillText}</div>
                  <div class="title">{promo.title}</div>
                  <div class="text-small-video">
                    {promo.description}
                  </div>
                </div>
              </div>
            </a>
          </div>
          {#if promo.sourceMedium && promo.favouriteContentType}
            <div class="favouriteBtnWrapper">
              <Favourite
                sourceMedium={promo.sourceMedium}
                favouriteContentType={promo.favouriteContentType}
                contentId={promo.contentId}
              />
            </div>
          {/if}
        </div>
      {:else}
        <div class="wrapper">
          <a
            href={promo.url + campaign}
            target="_blank"
            on:click={() =>
              trackEvent({
                action: 'click:further-navigation-with-image',
                label: promo.title,
              })}
            use:impression={`promo:image-${promo.alt}`}
          >
            <img
              width="496"
              height="279"
              src={promo.src}
              alt={`Promobilde for ${promo.alt}`}
            />
            <div class="bottomContent">
              <div class="text">
                <div class="pillText">{promo.pillText}</div>
                <div class="title">{promo.title}</div>
                <div class="text-small">
                  {promo.description}
                </div>
              </div>
            </div>
          </a>

          {#if promo.sourceMedium && promo.favouriteContentType}
            <div class="favouriteBtnWrapper">
              <Favourite
                sourceMedium={promo.sourceMedium}
                favouriteContentType={promo.favouriteContentType}
                contentId={promo.contentId}
              />
            </div>
          {/if}
        </div>
      {/if}
    </li>
  {/each}
</ul>

<style>
  ul {
    list-style: none;
  }

  li {
    margin-bottom: 1rem;
  }
  .video-wrapper {
    background: var(--mgp-purple-900);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .video {
    width: 100%;
  }

  .text-small-video {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
  a {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 31rem;
  }

  img {
    height: auto;
    width: 100%;
  }
  .wrapper {
    background: var(--mgp-purple-900);
    width: 100%;
    display: grid;
    justify-items: center;
  }
  .text {
    text-align: start;
    padding: 1rem 1rem 0;
    font-size: 1.5rem;
  }

  .bottomContent {
    width: 100%;
  }
  .pillText {
    width: fit-content;
    border-radius: 2px;
    font-weight: 600;
    font-size: 0.8rem;
    color: darkblue;
    padding: 0.1rem 0.2rem;
    background: #b2cff5;
    margin-bottom: 0.2rem;
  }

  .title {
    line-height: 1.2;
    margin-top: 0.8rem;
  }

  .text-small {
    font-size: 0.9rem;
  }

  .favouriteBtnWrapper {
    width: 90%;
    margin-bottom: 1rem;
  }
</style>
